<template>
    <el-container class="h-screen">
        <el-header class="bg-primary">
            <div class="flex justify-between items-center">
                <div class="el-header-left flex">
                    <div
                        class="el-nav-icon"
                        :class="{ 'el-nav-icon--active': !collapse }"
                        @click.prevent="collapse = !collapse"
                    ></div>
                    <div
                        class="el-customer-select"
                        @click.prevent="container.show = true"
                    >
                        <span v-if="selectedContainer">{{
                            selectedContainer.Description
                        }}</span>
                        <span class="el-customer-icon"></span>
                        <span class="el-customer-dropdown-icon"></span>
                    </div>

                    <h1
                        v-if="env === 'development'"
                        style="
                            color: white;
                            text-transform: uppercase;
                            font-weight: bold;
                            border: 1px solid white;
                            padding: 3px;
                            padding-top: 10px;
                            background: red;
                        "
                    >
                        DEV
                    </h1>
                </div>
                <div class="el-header-right">
                    <el-dropdown trigger="click" ref="notificationCenter">
                        <span
                            class="el-notification-block"
                            @click="readNotificationCenter()"
                        >
                            <el-badge
                                is-dot
                                v-if="notificationCount"
                                :value="notificationCount"
                                :max="99"
                                class="item"
                            >
                                <i class="el-icon-bell" />
                            </el-badge>
                            <i v-if="!notificationCount" class="el-icon-bell" />
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <stc-notification-center
                                :notifications="notifications"
                            ></stc-notification-center>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="el-lang-block">
                    <el-dropdown trigger="click">
                        <span class="el-lang-dropdown">
                            {{ this.selectedLanguage.name }}
                            <span
                                class="el-flag-wrapper flag-icon"
                                :class="this.selectedLanguage.flag"
                            ></span>
                            <span class="el-customer-dropdown-icon"></span>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                v-if="noFallbackLang"
                                @click.native="changeLanguage('no-lang')"
                            >
                                No Lang
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="changeLanguage('en-US')"
                            >
                                {{ $t('data.label.english') }}
                                <span
                                    class="
                                        el-flag-wrapper
                                        flag-icon flag-icon-gb
                                    "
                                ></span>
                            </el-dropdown-item>
                            <el-dropdown-item
                                @click.native="changeLanguage('sv-SE')"
                                divided
                            >
                                {{ $t('data.label.swedish') }}
                                <span
                                    class="
                                        el-flag-wrapper
                                        flag-icon flag-icon-se
                                    "
                                ></span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="el-header-right">
                    <div class="el-profile-block">
                        <el-dropdown trigger="click" :hide-on-click="false">
                            <span class="el-profile-dropdown">
                                {{ fullName }}
                                <span class="el-user-icon">
                                    <img src="/images/icon/man.png" />
                                </span>
                                <span class="el-customer-dropdown-icon"></span>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="el-profile-dropdown-block"
                            >
                                <el-dropdown-item
                                    @click.native="passwordChange = true"
                                    >{{
                                        $t('text.changePassword')
                                    }}</el-dropdown-item
                                >
                                <el-dropdown-item
                                    divided
                                    v-if="isPinVisible"
                                    class="pin-code-text"
                                >
                                    <div>
                                        <span class="pin-code-text-label"
                                            >{{ $t('text.pinCode') }}:</span
                                        >
                                        <span v-if="isShowHidePinCode">{{
                                            pinCode
                                        }}</span>
                                        <span v-if="!isShowHidePinCode"
                                            >*******</span
                                        >
                                        <span
                                            v-bind:class="[
                                                isShowHidePinCode
                                                    ? 'show-eye'
                                                    : 'close-eye',
                                            ]"
                                            class="
                                                el-icon-view
                                                pin-text-eye-icon
                                            "
                                            @click="showHidePinCode"
                                        ></span>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item
                                    @click.native="openUserManual"
                                    divided
                                    >{{
                                        $t('text.userManual')
                                    }}</el-dropdown-item
                                >
                                <el-dropdown-item
                                    @click.native="logout"
                                    divided
                                    >{{ $t('text.logOut') }}</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
        </el-header>
        <el-container>
            <el-aside
                width="auto"
                class="z-10 border-r"
                :class="{ 'el-nav-expand': !collapse }"
            >
                <el-menu
                    :default-active="$route.path"
                    router
                    unique-opened
                    :collapse="collapse"
                    class="border-r-0 side-menu"
                >
                    <el-menu-item
                        class="el-menu-item-dashboard"
                        index="/"
                        :route="{ name: 'dashboard' }"
                        v-show="permissions.includes('ACTOR_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.dashboard')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-booking"
                        index="/bookings"
                        :route="{ name: 'bookings' }"
                        v-show="!isBlc && permissions.includes('ACTOR_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.bookings')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-user-tool"
                        index="/userTool"
                        :route="{ name: 'userTool' }"
                        v-show="permissions.includes('USER_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.userTool')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-users"
                        index="/userGroups"
                        :route="{ name: 'userGroups' }"
                        v-show="permissions.includes('USER_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.userGroups')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-checkpoints"
                        index="/gates"
                        :route="{ name: 'gates' }"
                        v-show="permissions.includes('CHECKPOINT_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.checkpoints')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-unloading"
                        index="/unloading-areas"
                        :route="{ name: 'unloading-areas' }"
                        v-show="permissions.includes('UNLOADINGAREA_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.unloadingAreas')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-global-schedule"
                        index="/global-schedule"
                        :route="{ name: 'global-schedule' }"
                        v-show="permissions.includes('SCHEDULETEMPLATE_READ')"
                    >
                        <span slot="title">{{
                            $t('navigation.globalschedule')
                        }}</span>
                    </el-menu-item>
                    <el-menu-item
                        class="el-menu-item-suppliers"
                        index="/supplier"
                        :route="{ name: 'supplier' }"
                        v-if="
                            selectedContainer &&
                            selectedContainer.ContainerType !== 'CCC'
                        "
                        v-show="permissions.includes('SUPPLIER_VIEW')"
                    >
                        <span slot="title">{{
                            $t('navigation.suppliers')
                        }}</span>
                    </el-menu-item>
                    <el-submenu
                        v-show="isBlc"
                        class="el-menu-item-blc"
                        index="/blc"
                    >
                        <template slot="title">
                            <span
                                slot="title"
                                v-if="selectedContainer"
                                v-text="selectedContainer.Description"
                            ></span>
                        </template>
                        <el-menu-item-group>
                            <span
                                slot="title"
                                v-if="selectedContainer"
                                v-text="selectedContainer.Description"
                            ></span>
                            <el-menu-item
                                index="/blc/material-manager"
                                :route="{ name: 'blc/material-manager' }"
                            >
                                {{ $t('navigation.materialManager') }}
                            </el-menu-item>
                            <!--                            <el-menu-item-->
                            <!--                                index="/userTool"-->
                            <!--                                :route="{ name: 'userTool' }"-->
                            <!--                                v-show="permissions.includes('USER_READ')"-->
                            <!--                            >{{ $t('navigation.userTool') }}-->
                            <!--                            </el-menu-item>-->
                            <el-menu-item
                                index="/blc/route-planner"
                                :route="{ name: 'blc/route-planner' }"
                            >
                                {{ $t('navigation.routePlanner') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/blc/follow-up"
                                :route="{ name: 'blc/follow-up' }"
                            >
                                {{ $t('navigation.followUp') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/supplier"
                                :route="{ name: 'supplier' }"
                                v-if="
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.supplierTool') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/vehicleTool"
                                :route="{ name: 'vehicleTool' }"
                                v-if="
                                    permissions.includes('VEHICLE_READ') &&
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.vehicleTool') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/event-tool"
                                :route="{ name: 'eventTool' }"
                                v-if="
                                    permissions.includes('USER_READ') &&
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.eventTool') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/bookingOverviewTool"
                                :route="{ name: 'bookingOverviewTool' }"
                                v-if="
                                    permissions.includes('USER_READ') &&
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.bookingOverviewTool') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/waiting-areas"
                                :route="{ name: 'waiting-areas' }"
                                v-if="
                                    permissions.includes('WAITINGAREA_READ') &&
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.waitingAreas') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/checkpoint-tool"
                                :route="{ name: 'checkpoint-tool' }"
                                v-if="
                                    permissions.includes('WAITINGAREA_READ') &&
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.waitingAreaTool') }}
                            </el-menu-item>
                            <el-menu-item
                                index="/inventory"
                                :route="{ name: 'inventory' }"
                                v-if="
                                    selectedContainer &&
                                    selectedContainer.ContainerType === 'CCC'
                                "
                            >
                                {{ $t('navigation.inventory') }}
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-main>
                <router-view></router-view>
                <el-dialog
                    :visible.sync="container.show"
                    @close="resetContainer"
                    v-if="selectedContainer"
                    width="30%"
                >
                    <span slot="title">
                        <div class="flex justify-between">
                            <span>{{ $t('title.chooseContainer') }}</span>
                            <span
                                class="mr-4"
                                v-if="permissions.includes('CONTAINER_WRITE')"
                            >
                                <a
                                    @click="manageContainers"
                                    class="text-white underline"
                                    >{{ $t('title.text.manageContainers') }}</a
                                >
                            </span>
                        </div>
                    </span>
                    <div>
                        <autocomplete
                            ref="autocomplete"
                            :placeholder="$t('title.text.searchContainers')"
                            :source="containers"
                            input-class="form-control"
                            results-display="Description"
                            results-value="Description"
                            name="Description"
                            @selected="selectedContainerFromAutocomplete"
                            style="margin-bottom: 10px"
                        >
                        </autocomplete>
                    </div>
                    <el-tree
                        ref="containerTreeRef"
                        :data="containerTree"
                        :props="container.defaultProps"
                        :default-checked-keys="[selectedContainer.ContainerID]"
                        :node-key="container.nodeKey"
                        highlight-current
                        accordion
                        @node-click="
                            container.checked = $event
                            clearSearchAutocomplete()
                        "
                    ></el-tree>
                    <span slot="footer" class="dialog-footer">
                        <el-button
                            class="el-dialog__footer-btn"
                            @click="resetContainer"
                            >{{ $t('modal.button.cancel') }}</el-button
                        >
                        <el-button
                            class="el-dialog__footer-btn"
                            type="primary"
                            @click="changeContainer"
                            >{{ $t('modal.button.confirm') }}</el-button
                        >
                    </span>
                </el-dialog>

                <el-dialog
                    :visible.sync="showErrorPopup"
                    @close="resetCurrentError"
                    width="30%"
                >
                    <span slot="title">
                        <div class="flex justify-between">
                            <span>{{ $t('title.accessDenied') }}</span>
                        </div>
                    </span>
                    <span
                        >{{
                            this.$i18n.i18next.t('text.accessDenied', {
                                section: errors.Permission,
                            })
                        }}
                        <a href="#" @click.prevent="requestAccess()">
                            {{ $t('text.clickHere') }}
                        </a>
                    </span>
                    <span slot="footer"> </span>
                </el-dialog>

                <el-dialog
                    class="el-dialog--dark"
                    :visible.sync="passwordChange"
                    @close="cancelChangePassword"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :show-close="!isChangePasswordForced"
                    width="30%"
                >
                    <span slot="title">
                        <span>{{ $t('text.changePassword') }}</span>
                    </span>
                    <div
                        class="password-form-group"
                        style="height: 200px !important"
                    >
                        <span
                            v-if="isChangePasswordForced"
                            style="color: #52bab2"
                            >{{ $t('text.firstTimePasswordChange') }}</span
                        >
                        <el-form
                            ref="form"
                            :model="form"
                            :rules="rules"
                            size="small"
                        >
                            <v-text-field
                                :label="$t('form.label.password_1')"
                                v-model="password_change_1"
                                :type="
                                    password_change_show ? 'text' : 'password'
                                "
                                required
                            ></v-text-field>
                            <v-text-field
                                :label="$t('form.label.password_2')"
                                v-model="password_change_2"
                                :type="
                                    password_change_show ? 'text' : 'password'
                                "
                                required
                            >
                            </v-text-field>
                            <v-btn-toggle
                                v-model="text"
                                style="margin-left: 10px"
                            >
                                <v-btn
                                    flat
                                    dark
                                    color="dark"
                                    @click="
                                        password_change_show =
                                            !password_change_show
                                    "
                                >
                                    {{ password_change_button_text }}
                                </v-btn>
                                <v-btn
                                    color="dark"
                                    @click="generate"
                                    loader="loading"
                                    :disabled="password_change_loading"
                                >
                                    {{ $t('form.button.generate') }}
                                </v-btn>
                            </v-btn-toggle>
                        </el-form>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button
                            v-if="!isChangePasswordForced"
                            class="el-dialog__footer-btn"
                            @click="cancelChangePassword"
                            >{{ $t('modal.button.cancel') }}</el-button
                        >
                        <el-button
                            class="el-dialog__footer-btn"
                            type="primary"
                            :loading="loading"
                            @click="changePassword"
                            >{{ $t('modal.button.confirm') }}</el-button
                        >
                    </span>
                </el-dialog>
            </el-main>
        </el-container>

        <!-- Chat component -->
        <stc-chat v-if="showChat" :socket="socket"></stc-chat>

        <!-- Timeline -->
        <div>
            <el-dialog :visible.sync="showTimeLine" width="40%">
                <span slot="title">
                    <div class="flex">
                        <span>{{ $t('form.label.statusHistory') }}</span
                        ><span>&nbsp;for {{ timelineTitle }}&nbsp;</span
                        ><span style="color: #309acc">{{
                            timelineTitleCode
                        }}</span>
                    </div>
                </span>
                <stc-timeline
                    v-if="showTimeLine"
                    :timelineId="timelineId"
                    :timelineType="timelineType"
                ></stc-timeline>
            </el-dialog>
        </div>

        <!-- Notification Settings -->
        <stc-notification-settings
            :showNotificationSettings="showNotificationSettings"
        ></stc-notification-settings>

        <!-- Global Alert -->
        <v-snackbar
            v-model="showAlertSnack"
            :timeout="4000"
            :top="'top'"
            :vertical="'vertical'"
        >
            <span
                @click="showAlertSnack = false"
                style="
                    color: #ffffff;
                    text-align: right;
                    font-weight: bold;
                    cursor: pointer;
                "
                >X</span
            >
            <stc-notification :source="alertSnack"></stc-notification>
        </v-snackbar>
    </el-container>
</template>

<script>
import { io } from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment'
import { DateTime } from 'luxon'
import StcPassword from './../components/Password'
import { mapGetters, mapActions, mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import InteractWithActor from '../mixins/interact-with-actor'
import ChatMixin from '../mixins/chat-mixin'
import Chat from './../components/chat/Chat'
import TimeLine from './../components/timeline/TimeLine'
import NotificationCenter from './../components/chat/NotificationCenter'
import NotificationSettings from '../components/chat/NotificationSettings'
import Notification from '../components/chat/Notification'
import qs from 'qs'

export default {
    name: 'dashboard',

    data() {
        return {
            loading: false,
            form: {
                password: '',
            },
            rules: {
                password: [
                    {
                        required: true,
                        message: 'Password is required.',
                        trigger: 'blur',
                    },
                    {
                        min: 8,
                        message: 'Password should have at least 8 characters.',
                        trigger: 'blur,change',
                    },
                ],
            },
            collapse: true,
            showErrorPopup: false,
            passwordChange: false,
            container: {
                show: false,
                nodeKey: 'ContainerID',
                defaultProps: {
                    children: 'Children',
                    label: 'Description',
                },
                checked: {},
            },
            password_change_1: '',
            password_change_2: '',
            password_change_loading: false,
            password_change_show: false,
            text: 'text',
            password: 'password',
            env: '',
            pinCode: '',
            isPinVisible: false,
            isShowHidePinCode: false,
            showChat: false,
            notificationCount: 0,
            socket: '',
            notifications: '',
            showTimeLine: false,
            timelineId: '',
            timelineType: '',
            timelineTitle: '',
            timelineTitleCode: '',
            showNotificationSettings: false,
            showAlertSnack: false,
            alertSnack: '',
            isChangePasswordForced: false,
            isLogout: false,
        }
    },

    components: {
        'stc-password': StcPassword,
        autocomplete: Autocomplete,
        'stc-chat': Chat,
        'stc-notification-center': NotificationCenter,
        'stc-timeline': TimeLine,
        'stc-notification-settings': NotificationSettings,
        'stc-notification': Notification,
    },

    mixins: [InteractWithActor, ChatMixin],

    computed: {
        ...mapState(['language']),

        ...mapGetters([
            'isBlc',
            'errors',
            'permissions',
            'containerTree',
            'containers',
            'selectedLanguage',
            'selectedContainer',
        ]),

        noFallbackLang() {
            return process.env.VUE_APP_LANG_FALLBACK == 'false'
        },

        fullName() {
            let user = this.$auth.user()

            return user.FirstName + ' ' + user.LastName
        },

        password_change_button_text() {
            return this.show
                ? this.$t('form.button.hide')
                : this.$t('form.button.show')
        },
    },

    async created() {
        if (!this.$auth.user().IsPasswordUpdated) {
            this.passwordChange = true
            this.isChangePasswordForced = true
        }
        this.env = process.env.VUE_APP_ENVIRONMENT
        this.updateUserLanguage()
        await this.fetchAllContainers()
        this.showPinCode()
        await this.getUserMessages()

        // This scheduler will refresh the token
        this.refreshData()
    },

    mounted() {
        // here we are waiting until downloading all the network
        // resources since language files are loading asynchronously
        let t = setInterval(() => {
            if (document.readyState === 'complete') {
                this.changeLanguage(this.selectedLanguage.isoName)
                clearInterval(t)
            }
        }, 500)

        Events.$on('show-notification-center', () => {
            this.$refs.notificationCenter.$el
                .getElementsByClassName('el-icon-bell')[0]
                .click()
        })

        Events.$on('show-timeline', (timelineId, timelineType, code) => {
            this.showTimeLine = true
            this.timelineId = timelineId
            this.timelineType = timelineType
            this.timelineTitleCode = code
            switch (timelineType) {
                case 'ACTOR':
                    this.timelineTitle = 'Booking'
                    break
                case 'BLC_NOTIFICATION':
                    this.timelineTitle = 'BLC Notification'
                    break
                case 'BLC_ROUTE':
                    this.timelineTitle = 'Route'
                    break
                case 'WA_NOTIFICATION':
                    this.timelineTitle = 'Waiting Area Notification'
                    break
                case 'PACKAGE_GROUP':
                    this.timelineTitle = 'Package Group'
                    break
                case 'PACKAGE_ITEM':
                    this.timelineTitle = 'Pacakge Item'
                    break
                case 'USER':
                    this.timelineTitle = 'User'
                    break
                default:
                    break
            }
        })

        Events.$on('show-chat', (isShow) => {
            this.showChat = isShow
        })

        Events.$on('show-notification-settings', (isShow) => {
            if (isShow) {
                this.$refs.notificationCenter.$el
                    .getElementsByClassName('el-icon-bell')[0]
                    .click()
            }
            this.showNotificationSettings = isShow
        })

        this.socket = io(process.env.VUE_APP_CHAT_API, {
            reconnectionDelayMax: 10000,
            auth: {
                Token: this.$auth.token(),
                DeviceType: 'WEB',
                IsActive: true,
                UserId: this.$auth.user().UserID,
            },
        })

        this.socket.emit('join-room', 'notification', this.$auth.user().UserID)
        this.socket.emit(
            'join-room',
            'refresh-calendar',
            this.$auth.user().UserID
        )

        this.socket.on('notification', (notification) => {
            if (notification) {
                this.notifications.push(notification)
                // Increase notification badge count
                this.notificationCount++

                // Show global alert
                this.showAlertSnack = true
                const createdAt = notification.CreatedAt
                    ? moment(
                          DateTime.fromISO(notification.CreatedAt, {
                              zone: 'utc',
                          }).toJSDate()
                      ).format('YYYY-MM-DD HH:mm:ss')
                    : moment().format('YYYY-MM-DD HH:mm')
                this.alertSnack = {
                    MessageBody: notification.Message,
                    CreatedAt: createdAt,
                    Author: notification.Sender
                        ? notification.Sender.FirstName +
                          ' ' +
                          notification.Sender.LastName
                        : null,
                    ChannelId: notification.ChannelId,
                    ChannelName: notification.ChannelName,
                    Title: notification.Title,
                    Type: notification.Type,
                    CustomType: notification.CustomType,
                    ShortCode: notification.ShortCode,
                    Data: notification.Data,
                    IsRead: notification.IsRead,
                }
            }
        })

        // Refresh Booking Calendar
        this.socket.on('refresh-calendar', (data) => {
            if (
                data &&
                data.containerId &&
                data.containerId === this.selectedContainer.ContainerID
            ) {
                console.log(data, this.selectedContainer.ContainerID)
                Events.$emit('calendar-refresh-from-notifications')
                Events.$emit('wa-notifications-refresh')
            }
        })

        Events.$on('notification-read', () => {
            if (this.notificationCount > 0) {
                this.notificationCount--
            }
        })
    },

    beforeDestroy() {
        Events.$off('show-chat')
        Events.$off('show-notification-center')
        Events.$off('notification-read')
        Events.$off('show-timeline')
        Events.$off('show-notification-settings')
        this.socket.disconnect()
    },

    watch: {
        selectedContainer(container) {
            this.fetchContainerPermissions(container)
        },

        language(language) {
            this.updateUserLanguage(language)
        },

        errors(errors) {
            this.handleErrorPopup(errors)
        },

        $route() {
            this.showChat = false
        },
    },

    methods: {
        ...mapActions([
            'setErrors',
            'changeLanguage',
            'setAllContainers',
            'fetchAllContainers',
            'setSelectedContainer',
            'setContainerPermissions',
            'fetchContainerPermissions',
        ]),

        async logout() {
            this.isLogout = true
            this.setAllContainers([])
            this.setSelectedContainer('')
            this.setContainerPermissions([])
            this.$cookies.remove('refresh_token')
            await this.$auth.logout({
                redirect: {
                    name: 'login',
                },
            })
        },

        manageContainers() {
            this.container.show = false

            this.setSelectedContainer(this.container.checked)

            this.$router.replace({ name: 'containers' })
        },

        changeContainer() {
            let container = _.cloneDeep(this.container.checked)

            if (!_.isEmpty(container)) {
                this.setSelectedContainer(container)
            }

            this.container.show = false

            this.$router.replace({ name: 'dashboard' })
        },

        clearSearchAutocomplete() {
            this.$refs.autocomplete.clear()
        },

        selectedContainerFromAutocomplete(selected) {
            if (selected && selected.selectedObject) {
                this.container.checked = selected.selectedObject
                // Reset tree
                this.$refs.containerTreeRef.store.currentNode = null
                Object.keys(this.$refs.containerTreeRef.store.nodesMap).map(
                    (key) => {
                        this.$refs.containerTreeRef.store.nodesMap[
                            key
                        ].checked = false
                        this.$refs.containerTreeRef.store.nodesMap[
                            key
                        ].expanded = false
                    }
                )

                this.$nextTick(() => {
                    // Populate tree
                    this.$refs.containerTreeRef.store.currentNode =
                        selected.selectedObject
                    Object.keys(this.$refs.containerTreeRef.store.nodesMap).map(
                        (key) => {
                            if (
                                key === selected.selectedObject.ContainerID ||
                                key ===
                                    selected.selectedObject.ParentContainerID ||
                                key === '16cf2196-ac4a-47ce-a4c5-5c742924761b' // Wellsec root container ID
                            ) {
                                this.$refs.containerTreeRef.store.nodesMap[
                                    key
                                ].checked = false
                                this.$refs.containerTreeRef.store.nodesMap[
                                    key
                                ].expanded = true
                            }
                        }
                    )
                })
            }
        },

        updateUserLanguage(language) {
            language = language || this.selectedLanguage.isoName

            let me = this.$auth.user()

            if (me.Culture === language) return

            let payload = {
                ...this.$auth.user(),
                Culture: language,
            }

            this.$auth.user(payload)
            this.$http.put(`User/Me`, payload)
        },

        handleErrorPopup(errors) {
            if (!_.isEmpty(errors)) {
                this.showErrorPopup = true
                return
            }
            this.showErrorPopup = false
        },

        async requestAccess() {
            let user = this.$auth.user()
            let date = moment().format('YYYY-MM-DD HH:mm')
            let payload = {
                To: 'support@wellsec.se',
                Subject: '403-Permission Required',
                Body: `Action: ${this.errors.Action}<br />
                    Operation: ${this.errors.Uri}<br />
                    User: ${user.FirstName} ${user.LastName}<br />
                    User Email: ${user.UserName},<br />
                    Mobile: ${user.Phone}<br />
                    Container: ${this.selectedContainer.Description}<br />
                    DateTime: ${date}`,
            }
            try {
                await this.$http.post(`Util/SendEmail`, payload)
                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.created', {
                        section: this.$i18n.i18next.t('text.supportTicket'),
                    }),
                })
                this.setErrors({})
            } catch (error) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.error.general'),
                })
            }
        },

        async changePassword() {
            if (!this.password_change_1) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'form.label.password_required'
                    ),
                })
                return
            }
            if (this.password_change_1.length < 8) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t('form.label.password_min'),
                })
                return
            }
            const passwordValidationRegex =
                /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g
            if (!this.password_change_1.match(passwordValidationRegex)) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'form.validation.passwordValidateMessage'
                    ),
                })
                return
            }
            if (!this.password_change_2) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'form.label.confirm_password_required'
                    ),
                })
                return
            }
            if (this.password_change_2.length < 8) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'form.label.confirm_password_min'
                    ),
                })
                return
            }
            if (!this.password_change_2.match(passwordValidationRegex)) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'form.validation.passwordValidateMessage'
                    ),
                })
                return
            }
            if (this.password_change_1 !== this.password_change_2) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'form.label.password_mismatch'
                    ),
                })
                return
            }
            this.loading = true
            try {
                await this.$refs.form.validate()

                await this.$http.post(`User/Me/SetPassword`, {
                    password: this.password_change_1,
                })

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.updated', {
                        section: this.$i18n.i18next.t('form.label.password'),
                    }),
                })

                this.$refs.form.resetFields()
                this.passwordChange = false

                if (this.isChangePasswordForced) {
                    this.logout()
                }
            } catch (e) {
                if (e === false) {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: 'There was a problem updating the password.',
                    })
                }
            }

            this.loading = false
        },

        cancelChangePassword() {
            this.password_change_1 = ''
            this.password_change_2 = ''
            this.passwordChange = false
        },

        resetContainer() {
            this.container.checked = {}
            this.container.show = false
        },

        resetCurrentError() {
            this.setErrors({})
        },

        async generate() {
            this.password_change_loading = true
            let { data } = await this.$http.get('Util/GeneratePassword')
            this.password_change_1 = data
            this.password_change_2 = data
            this.password_change_loading = false
        },

        async showPinCode() {
            const user = this.$auth.user()
            if (user && user.RelatedActorID) {
                const actor = await this.fetchActorByID(user.RelatedActorID)
                if (actor && actor.PinCode) {
                    this.isPinVisible = true
                    this.pinCode = actor.PinCode
                }
            }
        },

        showHidePinCode() {
            this.isShowHidePinCode = !this.isShowHidePinCode
        },

        openUserManual() {
            let url =
                'https://amz-s3-wel-buck1.s3-eu-west-1.amazonaws.com/docs/Anvandarmanual_en.pdf'
            if (this.selectedLanguage.name === 'English') {
                url =
                    'https://amz-s3-wel-buck1.s3-eu-west-1.amazonaws.com/docs/Anvandarmanual_en.pdf'
            } else if (this.selectedLanguage.name === 'Svenska') {
                url =
                    'https://amz-s3-wel-buck1.s3-eu-west-1.amazonaws.com/docs/Anvandarmanual_sv.pdf'
            }
            window.open(url, '_blank')
        },

        async readNotificationCenter() {
            Events.$emit('nc-set-custom-type')
            this.notificationCount = 0
            this.readNotifications()
        },

        async getUserMessages() {
            this.notifications = await this.fetchUserMessages(1, 'ALL')
            this.notificationCount = this.notifications.length
        },

        refreshData() {
            const self = this
            setInterval(() => {
                if (!self.isLogout) {
                    const data = qs.stringify({
                        grant_type: 'refresh_token',
                        refresh_token: window.$cookies.get('refresh_token'),
                        client_id: '50B9A4FA-2C5D-41F8-828A-A1F7E29635A2',
                    })
                    self.$http.post(`/token`, data)
                }
            }, 21600000) // Every 6 hours
        },
    },
}
</script>

<style scoped lang="scss">
.side-menu:not(.el-menu--collapse) {
    width: 12rem;
}
.password-form-group {
    height: 150px;
}
.pin-code-text {
    cursor: default;
    text-align: center;
    padding-left: 40px;
}
.pin-code-text-label {
    margin-right: 5px;
}
.el-dropdown-menu__item--divided {
    border-radius: 0;
}
.pin-text-eye-icon {
    color: white;
    font-size: 18px;
    position: absolute;
    margin-top: 20px;
    margin-right: 15px;
    margin-left: 10px;
    cursor: pointer;
}
.show-eye {
    color: #30b1a3;
}
.close-eye {
    color: grey;
}
</style>
<style>
.snack--vertical .snack__content {
    height: 135px !important;
    padding: 15px !important;
}
.theme--light .input-group input {
    color: #989ea6;
}
</style>